import React from 'react';
import { Modal as SimpleModal } from '@/components/custom/modal/modal';
import { FlashcardQuiz } from '@/pages/study-guide/study-guide-block/flashcard-quiz';

export default function FlashcardGuideModal(props) {
  const { show, onClose, update } = props;

  const handleComplete = results => {
    // Atualiza dados do componente pai se necessário
    if (update) {
      update();
    }
    onClose();
  };

  const handleClose = () => {
    if (update) {
      update();
    }
    onClose();
  };

  return (
    <SimpleModal
      show={show}
      onClose={handleClose}
      contentClassName="simple-modal__content--flashcard"
      hideCloseButton
    >
      <FlashcardQuiz
        onComplete={handleComplete}
        onClose={handleClose}
        limit={10}
      />
    </SimpleModal>
  );
}
